import * as React from 'react';
import {View, Platform} from 'react-native';
import {IStateProps} from './model';
import {useStyles} from '../../hooks/styles';
import {Text} from '../text';

const dataSet = {
  dataSet: {
    class: 'counter',
  },
};

export default ({counterStyle, children, count, style}: IStateProps) => {
  const styles = useStyles(({theme, addShadow}) => ({
    container: {
      position: 'relative',
    },
    counterWrapper: {
      position: 'absolute',
      right: -7,
      top: -7,
    },
    counter: {
      ...addShadow({
        radius: 2,
        height: 2,
        color: theme.color.primaryBlackColor,
        opacity: 0.24,
      }),
      backgroundColor: theme.color.primaryColor,
      minWidth: 20,
      height: 20,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
    },
    counterText: {
      ...theme.fonts.label,
      color: theme.color.primaryNonGreyBackground,
      textAlign: 'center',
      minWidth: 20,
      height: 20,
      paddingLeft: 2,
      paddingRight: 2,
      lineHeight: Platform.OS === 'web' ? 21 : 20,
    },
  }));
  return (
    <View style={[styles.container, style]} {...dataSet}>
      {children}
      {count > 0 ? (
        <View style={[styles.counterWrapper, counterStyle]}>
          <View style={[styles.counter]}>
            <Text
              testID='unread-notifications-count-id'
              style={styles.counterText}
              numberOfLines={1}
              lineBreakMode='tail'>
              {count}
            </Text>
          </View>
        </View>
      ) : null}
    </View>
  );
};
